import { render, staticRenderFns } from "./CateringSolutions.vue?vue&type=template&id=3c14ef92&scoped=true"
import script from "./CateringSolutions.vue?vue&type=script&lang=js"
export * from "./CateringSolutions.vue?vue&type=script&lang=js"
import style0 from "./CateringSolutions.vue?vue&type=style&index=0&id=3c14ef92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14ef92",
  null
  
)

export default component.exports